/*** Importations *********************************************************************************/

import objectFitImages from 'object-fit-images/dist/ofi.es-modules.js';
import smoothscroll from 'smoothscroll-polyfill';


// Libraries

// import InfiniteScroll from 'infinite-scroll';
import GLightbox from 'glightbox/dist/js/glightbox.js';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock/lib/bodyScrollLock.es6.js';
import LazyLoad from 'vanilla-lazyload/dist/lazyload.esm.js';
import Swiper, { Navigation, Autoplay/*, Pagination *//*, EffectFade*/ } from 'swiper/core';


// Scripts Nubee

// import PageMenu from 'partials/page-menu.js';
// import toggleSearchForm from 'partials/toggle-search-form.js';
// import * as nubeeLoading from 'partials/nubee-loading.js';
import SmoothScroller from 'partials/smooth-scroller.js';
// import Tabs from 'partials/tabs.js';
import Accordion from 'partials/accordion.js';
import * as functions from 'partials/functions.js';
import 'partials/scroll-interval.js';
import 'partials/target-blank-security.js';
import CountUp from 'partials/countUp.js';
// import placeholderLabelUpdate from 'partials/placeholder-label.js';
import GLightboxNubee from 'partials/glightbox-nubee.js';
// import googleMapStyles from 'data/google-map-styles.js';
// import GoogleMap from 'partials/google-map.js';
import MobileMenu from 'partials/mobile-menu.js';
import imgCheck from 'partials/img-check.js';
// import FormValidation from 'partials/form-validation.js';
import InfiniteScrollSimple from 'partials/infinite-scroll-simple.js';
import LoadingButton from 'partials/loading-button.js';
// import FakeSticky from 'partials/fake-sticky.js';
import * as cookiesBar from 'partials/cookies-bar.js';

// On set toutes les variables globales et évènements qui les modifient ici
import * as globalVarFunctions from 'partials/global-variables.js';

var countUpNumbers = Array.prototype.slice.call( document.querySelectorAll( '.countup-number' ) );
var countUpInstances = [];

(function() {
	/*** Application des polyfills ********************************************************************/

	(function() {
		objectFitImages();
		smoothscroll.polyfill();

		if( 'function' != typeof window.Event ) {
			window.Event = CustomEvent;
		}
	}) ();


	/*** Variables globales ***************************************************************************/
	// global-variables.js
	// Chaînes traduisibles et autres variables provenant de theme-functions : window.nubeeGlobals.i18n.monPlugin.nomDeChaine

	globalVarFunctions.setGlobalVariables();


	/*** Les liens avec ancre qui mènent vers la même page deviennent seulement des ancres *******************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linksWithHash = document.querySelectorAll('a[href*="#"]');

		linksWithHash.forEach( function( thisLink ) {
			if( functions.urlsAreSamePage({ urls: [ thisLink.href, window.location.href ] }) ) {
				thisLink.href = thisLink.hash;
			}
		} );
	}) ();


	/*** Défiler doucement les liens ancres *******************************************************************/
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js
	// Ajuster la variable globale window.fixedElHeight

	(function() {
		if( window.smoothScroller ) {
			let smoothScrollLinks = document.querySelectorAll('a[href^="#"]:not([href="#"]):not(.no-smooth-scroll):not([target=_blank])');

			smoothScrollLinks.forEach( function( thisEl ) {
				if( functions.scriptsOk( thisEl ) ) {
					thisEl.addEventListener( 'click', function( event ) {
						if( 1 == event.which ) {
							event.preventDefault();
							window.smoothScroller.scrollTo({ target: thisEl.hash });
						}
					} );
				}
			});
		}
	}) ();


	/*** Ne rien faire au clic sur un lien vide (#) ************************************************************/

/* 	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let linkClicked = event.target.closest('a');
				let theHref = linkClicked ? linkClicked.getAttribute('href') : null;

				if( linkClicked && ( ! theHref || '#' == theHref ) && functions.scriptsOk( linkClicked ) ) {
					event.preventDefault();
				}
			}
		} );
	}) (); */


	/*** Images et backgrounds différents selon la taille de l'écran ********************************/
	// Requiert img-check.js

	(function() {
		if( 'function' == typeof imgCheck ) {
			window.addEventListener( 'resize', imgCheck );
			imgCheck();
		}
	}) ();


	/*** Lazy load des images et backgrounds *******************************************************************/
	// Requiert vanilla-lazyload

	(function() {
		let loadedEvent = new Event( 'lazyloaded' );

		window.siteLazyLoad = new LazyLoad({
			elements_selector: '.lazy',
			class_loading: 'lazy-loading',
			class_loaded: 'lazy-loaded',
			class_error: 'lazy-error',
			// use_native: true,
			callback_loaded: function( element ) {
				element.dispatchEvent( loadedEvent );
			},
		});
	}) ();


	/*** Google Maps ******************************************************************************************/
	// Requiert google-map.js
	// Requiert data/google-map-styles.js (copier-coller votre style là-dedans!)

	(function() {
		let mapParents = document.querySelectorAll('.the-map');

		mapParents.forEach( function( thisParent ) {
			if( functions.scriptsOk( thisParent ) ) {
				new GoogleMap({
					mapParent: thisParent,
					styles: googleMapStyles,
					markerIconUrl: window.nubeeGlobals.themeDir + '/assets/images/map-marker.svg'
				});
			}
		} );
	}) ();


	/*** Antispam maison sur les commentaires ****************************************************************/
	// À moins d'avoir activé le JS, la validation PHP refusera le commentaire.

	(function() {
		let commentForms = document.querySelectorAll('#commentform');

		commentForms.forEach( function( thisForm ) {
			thisForm.addEventListener( 'submit', function() {
				let legitInput = document.createElement( 'input' );
				legitInput.setAttribute( 'type', 'hidden' );
				legitInput.setAttribute( 'name', 'is_legit' );
				legitInput.value = 1;

				thisForm.appendChild( legitInput );
			} );
		} );
	}) ();


	/*** Mettre les label Gravity Forms en mode focus quand ils ont une valeur *************************/
	(function() {
		document.querySelectorAll( '.gfield' ).forEach( function( thisFormRow ) {
			thisFormRow.querySelectorAll( 'input, textarea, select' ).forEach( function( thisField ) {
				if( thisField.value !== '' ) { thisFormRow.classList.add( 'has-value' ); }

				thisField.addEventListener( 'change', function(){
					if( thisField.value !== '' ) {
						thisFormRow.classList.add( 'has-value' );
					} else {
						thisFormRow.classList.remove( 'has-value' );
					}
				} );
			} );
		} );
	}) ();

	/*** Désactiver le bouton après un click dans les formulaires Gravity Forms *************************/
	/*(function() {
		document.querySelectorAll( '.gform_button' ).forEach( function( thisButton ) {
			thisButton.addEventListener( 'click', function() {
				thisButton.closest('form').submit();
				thisButton.disabled = true;
			} );
		} );
	}) ();*/

	/*** Retour en haut **************************************************************************************/
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js

	(function() {
		let backToTop = document.querySelector('.back-to-top');

		if( backToTop && functions.scriptsOk( backToTop ) ) {
			backToTop.addEventListener( 'click', function() {
				if( 1 == event.which ) {
					window.smoothScroller.scrollTo({ target: document.body });
				}
			} );
		}
	}) ();


	/*** Menu mobile maison **********************************************************************************/

	(function() {
		new MobileMenu({
			menuSel: '.mobile-menu',
			buttonSel: '.mobile-menu-button',
			// debug: true,
			dropdownParentLinkActive: false,

			// Si on agrandit la fenêtre dans ce media query, le menu se ferme automatiquement.
			closeMediaQuery: '(min-width: 1000px)',

			// viewportMax: { width: 699 },
		});
	}) ();


	/*** Menu de page à hash qui se met à jour avec le scroll *********************************************/
	// Requiert page-menu.js

	/*
	(function() {
		window.pageMenus = [];

		window.addEventListener( 'initialscrollend', function() {
			window.pageMenus.push( new PageMenu({
				menuSel: '.page-menu-desktop',
				keepLatest: true,
				debug: false,
			}) );

			// Pas d'update ? Ce menu n'existe pas. On l'enlève de l'array.
			if( 'function' != typeof window.pageMenus[ window.pageMenus.length - 1 ].update ) {
				window.pageMenus.splice( -1, 1 );
			}

			// Version mobile avec select (il faut les dédoubler parce que ça ne marche pas pareil)

			window.pageMenus.push( new PageMenu({
				menuSel: '.page-menu-mobile',
				keepLatest: true,
				type: 'select',
				// pour pas faire l'auto-hash et le Analytics en double avec le menu bureau
				autoHash: false,
				logAnalytics: false,
				debug: false,
			}) );

			// Pas d'update ? Ce menu n'existe pas. On l'enlève de l'array.
			if( 'function' != typeof window.pageMenus[ window.pageMenus.length - 1 ].update ) {
				window.pageMenus.splice( -1, 1 );
			}

			// Update au scroll
			window.addEventListener( 'scrollinterval', function() {
				window.pageMenus.forEach( function( thisMenu ) {
					thisMenu.update();
				} );
			} );
		} );
	}) ();
	*/


	/*** Recherche qui s'ouvre/ferme en cliquant sur la loupe ************************************************/
	// Requiert toggle-search-form.js

	/*
	(function() {
		if( 'undefined' !== typeof toggleSearchForm ) {
			document.querySelectorAll('.search-form .search-button').forEach( function( thisEl ) {
				thisEl.addEventListener( 'click', function() {
					if( 1 == event.which ) {
						if( ! thisEl.closest('.search-form').classList.contains('open') ) {
							toggleSearchForm( event );
						} else {
							thisEl.closest('form').submit();
						}
					}
				} );
			} );
		}
	}) ();
	*/


	/*** InfiniteScrollSimple - Version maison plus légère *************************************************/
	// Requiert infinite-scroll-simple.js
	// Requiert regenerator-runtime (Babel veut ça pour les fonctions async)
	// Voir le début du fichier pour des events sur lesquels vous hooker

	(function() {
		let infiniteContainers = document.querySelectorAll('.iss-container');

		infiniteContainers.forEach(function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new InfiniteScrollSimple({
					container: thisEl,
					useInner: true,
					animate: true,
					hideButton: false,
					// debug: true,
				});
			}
		} );

	}) ();


	/*** LoadingButton - bouton pour AJAX avec preloader intégré *******************************************/

	(function() {
		let buttons = document.querySelectorAll('.loading-button');

		buttons.forEach(function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new LoadingButton({
					buttonEl: thisEl,
					debug: false,
				});

				// Le bouton est maintenant initialisé. On peut l'activer avec les méthodes :
				// buttonInstance.loadingStart() | buttonInstance.loadingEnd()
				// Fonctionnent aussi :
				// thisEl._loadingButton.loadingStart() | thisEl._loadingButton.loadingEnd()
			}
		} );
	}) ();



	/*** Infinite Scroll - Charger les prochains articles automatiquement **********************************/
	// Requiert infinite-scroll.pkgd.min.js
	/*
	(function() {
		let infiniteContainers = document.querySelectorAll('.infinite-scroll');

		infiniteContainers.forEach(function( thisEl ) {
			if( thisEl.parentNode.querySelector('.pagination .next') ) {
				let infiniteInstance = new InfiniteScroll(
					'.infinite-scroll',
					{
						path: '.pagination .next',
						append: '.infinite-scroll-element',
						prefill: false,
						history: false,
						// outlayer: outlayer,
						hideNav: '.pagination',
						status: '.infinite-scroll-status',
						debug: false,
					}
				);

				infiniteInstance.on( 'append', function( event, response, path, items ) {
					thisEl.parentNode.querySelector('.infinite-scroll-status').style.display = 'none';
					imgCheck();
					window.siteLazyLoad.update();
				} );
			}
		});
	}) ();
	*/


	/*** Dropdown de médias sociaux **************************************************************************/

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let buttonClicked = event.target.closest('.more-networks-button');
				let theContainer;
				let theDropdown;

				if( buttonClicked && functions.scriptsOk( buttonClicked ) ) {
					theContainer = buttonClicked.closest( '.more-networks' );
					theDropdown = theContainer.querySelector( '.more-networks-dropdown' );

					if( ! theContainer.classList.contains('animating') ) {
						theContainer.classList.add( 'animating' );

						if( ! theContainer.classList.contains( 'open' ) ) {
							theContainer.classList.add( 'open' );

							theDropdown.addEventListener( 'transitionend', function fadeInOver() {
								theContainer.classList.remove( 'animating' );
								theDropdown.removeEventListener( 'transitionend', fadeInOver );
							} );

						} else {
							theContainer.classList.remove( 'open' );

							theDropdown.addEventListener( 'transitionend', function fadeOutOver() {
								theContainer.classList.remove( 'animating' );
								theDropdown.removeEventListener( 'transitionend', fadeOutOver );
							} );
						}
					}
				}
			}
		} );
	}) ();

	/*** Sliders Swiper Partners ********************************************************************************/
	// Requiert Swiper

	(function() {
		Swiper.use( [ Autoplay ] );

		function initializeSlider(selector, options) {
			var swiperContainer = document.querySelector(selector);

			if (swiperContainer) {
				let slider = new Swiper(selector, options);

				swiperContainer.addEventListener("mouseleave", function() {
					if (slider && slider.autoplay) {
						slider.autoplay.start();
					}
				});
			}
		}

		initializeSlider('.page-block-partners .swiper.left', {
			speed: 8000,
			slidesPerView: 'auto',
			// centeredSlides: true,
			spaceBetween: 30,
			loop: true,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			autoplay: {
				delay: 1,
				disableOnInteraction: true,
				pauseOnMouseEnter: true,
				waitForTransition: false,
			},
			preloadImages: true,
			lazy: {
				loadPrevNext: true,
			},
			on: {
				beforeLoopFix: function() {
					window.siteLazyLoad.update();
				}
			},
		});
	}) ();

	(function() {
		Swiper.use( [ Autoplay ] );

		function initializeSlider(selector, options) {
			var swiperContainer = document.querySelector(selector);

			if (swiperContainer) {
				let slider = new Swiper(selector, options);

				swiperContainer.addEventListener("mouseleave", function() {
					if (slider && slider.autoplay) {
						slider.autoplay.start();
					}
				});
			}
		}

		initializeSlider('.page-block-partners .swiper.right', {
			speed: 8000,
			slidesPerView: 'auto',
			// centeredSlides: true,
			spaceBetween: 30,
			loop: true,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			autoplay: {
				delay: 1,
				disableOnInteraction: true,
				pauseOnMouseEnter: true,
				reverseDirection: true,
				waitForTransition: false,
			},
			preloadImages: true,
			lazy: {
				loadPrevNext: true,
			},
			on: {
				beforeLoopFix: function() {
					window.siteLazyLoad.update();
				}
			},
		});

	}) ();

	(function() {
		Swiper.use( [ Navigation, Autoplay ] );

		let latest_news = new Swiper( '.page-block-latest-news .swiper', {
			speed: 400,
			spaceBetween: 60,
			slidesPerView: 1,
			direction: 'horizontal',
			loop: false,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			preventClicks: false,
			preventClicksPropagation: false,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: false,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				500: { slidesPerView: 2, },
				1000: { slidesPerView: 3, },
				1900: { slidesPerView: 4, },
  			},
			on: {
				beforeLoopFix: function( ) {
					window.siteLazyLoad.update();
				}
			},
		});

	}) ();

	(function() {
		Swiper.use( [ Navigation, Autoplay ] );

		let testimonials = new Swiper( '.page-block-testimonials .swiper', {
			speed: 400,
			spaceBetween: 0,
			slidesPerView: 1,
			direction: 'horizontal',
			loop: true,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			preventClicks: false,
			preventClicksPropagation: false,
			grabCursor: true,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: false,
			longSwipes: true,
			longSwipesMs: 50,
			longSwipesRatio: .05,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			on: {
				beforeLoopFix: function( ) {
					window.siteLazyLoad.update();
				}
			},
		});

	}) ();

	/*** Sliders Glide ****************************************************************************************/
	// Requiert Glide (@glidejs/glide)
	// Ce slider n'a pas de fonction tout-en-un disponible.

	// large-slider-gallery
	/*(function() {
		let linkSliders = document.querySelectorAll('.page-block-large-slider-gallery .glide-slider');

		linkSliders.forEach( function( sliderEl ) {
			if( functions.scriptsOk( sliderEl ) ) {
				let sliderOptions = {
					type: 'slider',
					perView: 1,
					gap: 15,
					bound: true,
					rewind: true,
				};

				let sliderInstance = new Glide( sliderEl, sliderOptions );

				sliderInstance.on( 'move', function() {
					window.siteLazyLoad.update();
					sliderEl.classList.add( 'slider-animating' );
				} );

				sliderInstance.on( 'move.after', function() {
					window.siteLazyLoad.update();
					sliderEl.classList.remove( 'slider-animating' );
				} );

				sliderInstance.mount();
			}
		} );
	}) ();*/

	// testimonials-slider
	/*(function() {
		let linkSliders = document.querySelectorAll('.page-block-testimonials-slider .glide-slider');

		linkSliders.forEach( function( sliderEl ) {
			if( functions.scriptsOk( sliderEl ) ) {
				let sliderOptions = {
					type: 'carousel',
					perView: 1,
					gap: 50,
					bound: false,
					rewind: true,
					autoplay: 10000,
					hoverpause: true,
				};

				let sliderInstance = new Glide( sliderEl, sliderOptions );

				sliderInstance.on( 'move', function() {
					window.siteLazyLoad.update();
					sliderEl.classList.add( 'slider-animating' );
				} );

				sliderInstance.on( 'move.after', function() {
					window.siteLazyLoad.update();
					sliderEl.classList.remove( 'slider-animating' );
				} );

				sliderInstance.mount();
			}
		} );
	}) ();*/


	/*** Sliders Tiny Slider **********************************************************************************/
	// Requiert tns (tiny-slider)
	// Requiert initSliderTiny (tiny-slider-nubee.js)

	/*(function() {
		document.querySelectorAll('.tiny-slider').forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				initSliderTiny( thisEl );
			}
		} );
	}) ();*/


	/*** Empêcher la taille d'un élément de se réajuster une fois le chargement terminé ***********************/

	(function() {
		let lockedHeightEls = document.querySelectorAll('.lock-height-on-load');

		window.addEventListener( 'load', function() {
			lockedHeightEls.forEach( function( thisEl ) {
				if( functions.scriptsOk( thisEl ) ) {
					thisEl.style.height = thisEl.offsetHeight + 'px';
					thisEl.style.minHeight = 0;
					thisEl.style.maxHeight = 'none';
				}
			} );
		} );
	}) ();


	/*** Select qui redirigent quand on choisit une option ******************************************************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linkSelects = document.querySelectorAll('.link-select');

		linkSelects.forEach( function( thisSelect ) {
			if( functions.scriptsOk( thisSelect ) ) {
				[ 'change', 'keypress' ].forEach( function( eventName ) {
					thisSelect.addEventListener( eventName, function() {
						let selectedOption = thisSelect.options[ thisSelect.selectedIndex ];
						let targetUrl = selectedOption.dataset.url;

						if( targetUrl ) {
							if( /^#.+/.test( targetUrl ) ) {
								window.smoothScroller.scrollTo({ target: targetUrl });
							} else if( ! functions.urlsAreSamePage({ urls: targetUrl }) ) {
								window.location.href = targetUrl;
							}
						}
					} );
				} );
			}
		} );
	}) ();


	/*** Activation du doigt indicateur de scroll sur les blocs de statistiques appropriés **********************/
	// Requiert swipe-finger.js

	/*
	(function() {
		if( 'undefined' !== typeof SwipeFinger ) {
			let fingerWrappers = document.querySelectorAll('.swipe-finger-wrapper');
			fingerWrappers.forEach( function( thisWrapper ) {
				if( functions.scriptsOk( thisWrapper ) ) {
					let swipeFinger = new SwipeFinger({
						wrapper: thisWrapper,
						debug: false,
					});
				}
			} );
		}
	}) ();
	*/


	/*** Défile doucement au chargement d'une URL avec ancre ***************************************************/
	// Évènement "hashblocked" pour dire que le jump par défaut vient d'être bloqué
	// Évènement "initialscrollstart" pour dire qu'on s'apprête à faire le scroll
	// Évènement "initialscrollend" pour dire que la page est chargée ET l'ancre active est scrollée
	// S'il n'y a pas d'ancre (#) active, l'évènement est lancé dès le chargement.
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js

	/*(function() {
		let origHash = window.location.hash;
		let hashBlockedEvent = new Event( 'hashblocked' );
		let scrollStartEvent = new Event( 'initialscrollstart' );
		let scrollEndEvent = new Event( 'initialscrollend' );

		if( origHash ) {
			let targetEl = document.querySelector( origHash );

			if( targetEl ) {
				window.addEventListener( 'hashblocked', function() {
					window.addEventListener( 'smoothscrollend', function initialScrollEnd() {
						window.dispatchEvent( scrollEndEvent );
						window.removeEventListener( 'smoothscrollend', initialScrollEnd );
					} );

					window.dispatchEvent( scrollStartEvent );

					window.smoothScroller.scrollTo({
						target: origHash,
						historyState: history.state,
						historyAction: 'replace',
						// debug: true,
					});
				} );


				// Blocage du jump du navigateur par défaut
				setTimeout( function() {
					functions.changeHashWithoutScrolling( null, history.state, 'replace' );
					window.scrollTo( 0, 0 );
					window.dispatchEvent( hashBlockedEvent );
				}, 1 );
			} else {
				window.dispatchEvent( scrollEndEvent );
			}
		} else {
			window.dispatchEvent( scrollEndEvent );
		}
	}) ();*/


	/*** Donner la même hauteur à un groupe d'éléments **********************************************************/

	(function() {
		window.addEventListener( 'load', function() {
			let sameHeightGroups = document.querySelectorAll('.same-height-group');

			sameHeightGroups.forEach( function( thisGroup ) {
				if( functions.scriptsOk( thisGroup ) ) {
					let minWidth = thisGroup.dataset.sameHeightMinWidth || 0;
					let sameHeightEls = thisGroup.querySelectorAll('.same-height');
					let highestHeight = 0;

					if( window.vWidth >= minWidth ) {
						sameHeightEls.forEach( function( thisEl ) {
							highestHeight = Math.max( thisEl.clientHeight, highestHeight );
						} );

						sameHeightEls.forEach( function( thisEl ) {
							thisEl.style.minHeight = highestHeight + 'px';
						} );
					}
				}
			} );
		} );
	}) ();


	/*** smoothFadeIn - effet d'apparition lorsque dans le viewport *****************************************/
	// Requiert functions.smoothFadeIn
	// Options dans general-styles.scss

	(function() {
		let fadeInItems = document.querySelectorAll('.smooth-fade-in');

		fadeInItems.forEach( function( thisEl ) {
			functions.smoothFadeIn( thisEl );

			window.addEventListener( 'scrollinterval', function() {
				functions.smoothFadeIn( thisEl );
			} );
		} );
	}) ();



	/*** Onglets ***************************************************************************************/
	// Requiert tabs.js


	/*(function() {
		let tabsContainers = document.querySelectorAll('.tabs-block');

		tabsContainers.forEach( function( thisEl ) {
			new Tabs({
				container: thisEl,
				debug: true,
			});
		} );
	}) ();*/



	/*** Accordion *************************************************************************************/
	// Requiert accordion.js


	(function() {
		let accordionsEl = document.querySelectorAll('.accordion .accordion-item');

		accordionsEl.forEach( function( el ) {
			new Accordion( el );
		} );
	}) ();


	/*** Tooltips tippy *************************************************************************************/
	// Requiert tippy.js
	/*
	(function() {
		tippy( '[data-tippy-content]', {
			theme: 'light',
			flipBehavior: [ 'bottom', 'left' ],
		} );
	}) ();
	*/


	/*** Lightbox et popups avec GLightbox ******************************************************************/
	// Requiert GLightbox (glightbox)
	// Requiert glightbox-nubee.js

	(function() {
		// Éléments seuls.
		let lightboxEls = document.querySelectorAll('.lightbox');
		lightboxEls.forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new GLightboxNubee({
					links: thisEl,
					// debug: true,
				});
			}
		} );

		// Galeries. (Attention de donner une classe différente à chaque galerie de la page.)
		// Utilisez data-lightbox-element-class="ma-classe" sur .lightbox-gallery pour l'identifier.
		let lightboxGals = document.querySelectorAll('.lightbox-gallery');
		lightboxGals.forEach( function( thisGal ) {
			if( functions.scriptsOk( thisGal ) ) {
				new GLightboxNubee({
					galleryParent: thisGal,
					// debug: true,
				});
			}
		} );

		// On peut maintenant accéder aux instances à partir des liens ou du parent de la galerie :
		// <un lien lightbox ou un div galerie>._GLightboxNubee
		// <un lien lightbox ou un div galerie>._GLightbox
	}) ();


	/*** Cookie de jusqu'au lendemain minuit pour les annonces *******************************/

	(function() {

		let currentDate = new Date();

		// Demain minuit
		let expirationDate = new Date(
				currentDate.getFullYear(),
				currentDate.getMonth(),
				currentDate.getDate() + 1,
				0, 0, 0
			);

		let announcementsEl = document.getElementById('announcements');

		if( announcementsEl ) {
			let	announcements = announcementsEl.querySelectorAll( '.announcement' ),
				announcements_count = announcements.length;

			announcements.forEach( function( thisAnnouncement ) {
				let thisAnnouncementCookie = functions.getCookie( thisAnnouncement.id );

				if( thisAnnouncementCookie !== 'is-hidden' ) {
					thisAnnouncement.classList.remove( 'is-hidden' );

					let thisAnnouncementCookieObj = document.querySelector( '#' + thisAnnouncement.id + ' .close-announcement' );

					if( thisAnnouncementCookieObj ) {
						thisAnnouncementCookieObj.addEventListener( 'click', function (event) {
							event.preventDefault();

							document.cookie = thisAnnouncement.id + "=is-hidden; expires=" + expirationDate.toGMTString + "; path=/";
							thisAnnouncement.classList.add( 'is-hidden' );

							if( announcementsEl.querySelectorAll( '.announcement.is-hidden' ).length === announcements_count ) {
								announcementsEl.classList.toggle('is-hidden');
							} else if( announcementsEl.querySelectorAll( '.announcement:not(.is-hidden)' ).length === 1 ) {
								announcementsEl.classList.remove('more-than-one');
							}
						}, false );
					}
				}
			});

			if( announcementsEl.querySelectorAll( '.announcement.is-hidden' ).length !== announcements_count ) {
				announcementsEl.classList.remove('is-hidden');
			}
		}
	}) ();



	/*** Boutons +/- des input type number *******************************************************************/
	// Requiert NumberInput (number-input.js)

	/*
	(function() {
		let inputs = document.querySelectorAll('.input-number');

		inputs.forEach( function( thisInput ) {
			let inputInstance = new NumberInput({
				input: thisInput,
			});
		} );
	}) ();
	*/


	/*** Datepickers avec flatpickr ***************************************************************************/
	// Requiert initFlatpickr (init-flatpickr.js)
	// Requiert flatpickr
	/*
	(function() {
		let dateFields = document.querySelectorAll('.input-date');

		dateFields.forEach( function( thisField ) {
			initFlatpickr( thisField );
		} );
	}) ();



	/*** fake-sticky ******************************************************************************************/
	// Requiert fake-sticky.js
	// Pour quand le CSS display: sticky; marche pas bien.

	// (function() {
	// 	let fakeStickies = document.querySelectorAll('.fake-sticky');

	// 	fakeStickies.forEach( function( thisEl ) {
	// 		if( functions.scriptsOk( thisEl ) ) {
	// 			let fakeStickyArgs = {
	// 				element: thisEl,
	// 				// debug: true,
	// 				minWidth: thisEl.dataset.fakeStickyMinWidth || null,
	// 				maxWidth: thisEl.dataset.fakeStickyMaxWidth || null,
	// 				minHeight: thisEl.dataset.fakeStickyMinHeight || null,
	// 				maxHeight: thisEl.dataset.fakeStickyMaxHeight || null,

	// 				// mediaQueries à [] = meilleure performance ; aucun ajustement au resize
	// 				// Définir des mediaQueries = bonne performance ; ajustement aux mediaQueries seulement
	// 				// mediaQueries à null = ajustement au pixel près
	// 				mediaQueries: [
	// 					'(min-height: 600px)', // height!
	// 				],
	// 			};

	// 			fakeStickyArgs.minHeight = thisEl.dataset.fakeStickyMinHeight || null;

	// 			new FakeSticky( fakeStickyArgs );
	// 		}
	// 	} );
	// }) ();


	/*** Formulaire de recherche - changement de l'URL cible quand on choisit une option au select *************/
	// Requiert multi-action-form.js

	// (function() {
	// 	let multiActionForms = document.querySelectorAll('.multi-action-form');

	// 	multiActionForms.forEach( function( thisEl ) {
	// 		if( functions.scriptsOk( thisEl ) ) {
	// 			new MultiActionForm({
	// 				form: thisEl,
	// 				sourceElSel: '.multi-action-form-url',
	// 				debug: true,
	// 			});
	// 		}
	// 	} );
	// }) ();

	/*** Gestion des préférence de cookies ***************************************/
	(function() {
		window.acceptedCookies = cookiesBar.getCookie('acceptedCookies');

		if( 'function' == typeof cookiesBar.cookieConsent ) {
			cookiesBar.cookieConsent();
		}
	}) ();

	/*** Nombres décoratifs qui comptent vers le haut ******************************************************/
	// Requiert countUp.js

	(function() {

		window.addEventListener( 'scrollinterval', function() {
			if( 'undefined' != typeof CountUp && 0 < countUpNumbers.length ) {
				// console.log(countUpInstances);
				countUpNumbers.forEach( function( element, index, iteratedArray ) {
					if( element && functions.isInViewport(element) ) {
						if( ! countUpInstances[index].error ) {
							element.classList.add( 'countup-counting', 'countup-init' );

							countUpInstances[index].start( function() {
								element.classList.add( 'countup-counted' );
								element.classList.remove( 'countup-counting' );
							} );
						} else {
							console.error( countUpInstances[index].error );
						}

						// On vient de lancer CountUp sur cet élément. On l'enlève de la liste des éléments à traiter.
						iteratedArray[index] = null;
					}
				} );
			}
		}, 50 );

		if( 'undefined' != typeof CountUp && 0 < countUpNumbers.length ) {
			countUpNumbers.forEach( function( element, index, iteratedArray ) {
				var endNumber = parseFloat( element.innerHTML );
				var startNumber = Math.max( 0, ( endNumber - 100 ) );
				var nbDecimals = functions.countDecimals( endNumber );
				var duration = 2; // Secondes
				var options = {
					useEasing: true,
					// Générée avec https://inorganik.github.io/countUp.js/
					easingFn: function(t, b, c, d) {
						var ts = (t /= d) * t;
						var tc = ts * t;
						return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
					},
					useGrouping: true,
					separator: nubeeGlobals.i18n.numbers.thousandSeparator,
					decimal: nubeeGlobals.i18n.numbers.decimalSeparator,
				};

				countUpInstances.push( new CountUp( element, startNumber, endNumber, nbDecimals, duration, options ) );
			} );
			//console.log( countUpNumbers );
		}
	}) ();


	// Email & phone link de-obfuscation (vanilla, no inline script, with semicolons)
	(function() {
		function decodeBase64( s ) {
			try { return atob( s ); } catch (e) { return ''; }
		}

		function hydratePhone( root ) {
			var els = (root || document).querySelectorAll('.nubee-tel-obf[data-tel]');
			for (var i = 0; i < els.length; i++) {
				var el = els[i];
				if (el.dataset.nubeeHydrated === '1') { continue; }
				var tel = decodeBase64(el.getAttribute('data-tel'));
				if (!tel) { continue; }
				el.setAttribute('href', 'tel:' + tel);
				if (!el.getAttribute('title')) { el.setAttribute('title', tel); }
				el.dataset.nubeeHydrated = '1';
			}
		}

		function hydrateMail( root ) {
			var els = (root || document).querySelectorAll('.nubee-mail-obf[data-mail]');
			for (var i = 0; i < els.length; i++) {
				var el = els[i];
				if (el.dataset.nubeeHydrated === '1') { continue; }
				var mail = decodeBase64(el.getAttribute('data-mail'));
				if (!mail) { continue; }
				el.setAttribute('href', 'mailto:' + mail);
				if (!el.getAttribute('title')) { el.setAttribute('title', mail); }
				el.dataset.nubeeHydrated = '1';
			}
		}

		function hydrateAll( root ) {
			hydratePhone( root );
			hydrateMail( root );
		}

		// Public APIs if you need to call them manually
		window.nubeeTelDeobfuscate = function() { hydratePhone(document); };
		window.nubeeMailDeobfuscate = function() { hydrateMail(document); };
		window.nubeeContactDeobfuscate = function() { hydrateAll(document); };

		// Auto-init on DOM ready
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', function() { hydrateAll(document); });
		} else {
			hydrateAll(document);
		}

		// Optional: handle content injected after load (AJAX, etc.)
		if ('MutationObserver' in window) {
			var mo = new MutationObserver(function(mutations) {
				for (var i = 0; i < mutations.length; i++) {
					for (var j = 0; j < mutations[i].addedNodes.length; j++) {
						var node = mutations[i].addedNodes[j];
						if (node && node.nodeType === 1) { hydrateAll(node); }
					}
				}
			});
			mo.observe(document.documentElement, { childList: true, subtree: true });
		}

		// Safety: prevent navigation if not yet hydrated
		document.addEventListener('click', function( e ) {
			var a = e.target.closest('a.nubee-tel-obf, a.nubee-mail-obf');
			if (!a) { return; }
			if (!a.getAttribute('href') || a.getAttribute('href') === '#') {
				e.preventDefault();
			}
		}, true);
	})();

}) ();